export default function moveKakaoMap(lat: number, lng: number, kakaoMapId: string | null) {
  const url = `kakaomap://look?p=${lat},${lng}`; // URL Scheme 생성
  const now = new Date().valueOf();

  setTimeout(() => {
    if (new Date().valueOf() - now > 100) return;

    if (kakaoMapId === null || kakaoMapId === undefined) {
      window.location.href = `https://map.kakao.com/link/map/${lat},${lng}`;
    } else {
      window.location.href = `https://place.map.kakao.com/${kakaoMapId}`;
    }
  }, 50);

  window.location.href = url; // URL Scheme 실행
}
